var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.LoaderForPrefill
    },
    on: {
      "update:active": function($event) {
        _vm.LoaderForPrefill = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_vm._v("Contracted Services")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-tabs', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "content-class": "mt-2"
    }
  }, [_c('b-tab', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "title": "FTL (Full Truck Load) Services",
      "title-link-class": _vm.linkClass(0)
    },
    on: {
      "click": function($event) {
        _vm.changeTab('FTL')
      }
    }
  }, [_c('table', {
    staticClass: "disableAll styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Booking Type")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FTLSurface),
      expression: "FTLSurface"
    }],
    attrs: {
      "type": "checkbox",
      "id": "FTLSurface"
    },
    domProps: {
      "checked": Array.isArray(_vm.FTLSurface) ? _vm._i(_vm.FTLSurface, null) > -1 : (_vm.FTLSurface)
    },
    on: {
      "click": function($event) {
        _vm.chkFTLRouteMode()
      },
      "__c": function($event) {
        var $$a = _vm.FTLSurface,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.FTLSurface = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.FTLSurface = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.FTLSurface = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Surface")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FTLServiceArray),
      expression: "FTLServiceArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "FTLForward",
      "value": "Forward"
    },
    domProps: {
      "checked": Array.isArray(_vm.FTLServiceArray) ? _vm._i(_vm.FTLServiceArray, "Forward") > -1 : (_vm.FTLServiceArray)
    },
    on: {
      "click": _vm.createAccordianDataForFTL,
      "__c": function($event) {
        var $$a = _vm.FTLServiceArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Forward",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.FTLServiceArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.FTLServiceArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.FTLServiceArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Forward")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FTLBookingArray),
      expression: "FTLBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "FTLCredit",
      "value": "Credit"
    },
    domProps: {
      "checked": Array.isArray(_vm.FTLBookingArray) ? _vm._i(_vm.FTLBookingArray, "Credit") > -1 : (_vm.FTLBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForFTL,
      "__c": function($event) {
        var $$a = _vm.FTLBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Credit",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.FTLBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.FTLBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.FTLBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Credit")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FTLBookingArray),
      expression: "FTLBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "FTLPay",
      "value": "To Pay"
    },
    domProps: {
      "checked": Array.isArray(_vm.FTLBookingArray) ? _vm._i(_vm.FTLBookingArray, "To Pay") > -1 : (_vm.FTLBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForFTL,
      "__c": function($event) {
        var $$a = _vm.FTLBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "To Pay",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.FTLBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.FTLBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.FTLBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("FTC")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FTLBookingArray),
      expression: "FTLBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "FTLPrePaid",
      "value": "PrePaid"
    },
    domProps: {
      "checked": Array.isArray(_vm.FTLBookingArray) ? _vm._i(_vm.FTLBookingArray, "PrePaid") > -1 : (_vm.FTLBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForFTL,
      "__c": function($event) {
        var $$a = _vm.FTLBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "PrePaid",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.FTLBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.FTLBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.FTLBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Prepaid")])])])])])])])])]), _vm._v(" "), _c('b-tab', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "title": "PTL (Part Truck Load) Services",
      "title-link-class": _vm.linkClass(1)
    },
    on: {
      "click": function($event) {
        _vm.changeTab('PTL')
      }
    }
  }, [_c('table', {
    staticClass: "disableAll styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Booking Type")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLSurface),
      expression: "PTLSurface"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLSurface"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLSurface) ? _vm._i(_vm.PTLSurface, null) > -1 : (_vm.PTLSurface)
    },
    on: {
      "click": _vm.chkPTLrouteModeSurface,
      "__c": function($event) {
        var $$a = _vm.PTLSurface,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLSurface = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLSurface = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLSurface = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Surface")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLSurfServiceArray),
      expression: "PTLSurfServiceArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLForward",
      "value": "Forward"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLSurfServiceArray) ? _vm._i(_vm.PTLSurfServiceArray, "Forward") > -1 : (_vm.PTLSurfServiceArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLSurfServiceArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Forward",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLSurfServiceArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLSurfServiceArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLSurfServiceArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Forward")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLSurfBookingArray),
      expression: "PTLSurfBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLCredit",
      "value": "Credit"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLSurfBookingArray) ? _vm._i(_vm.PTLSurfBookingArray, "Credit") > -1 : (_vm.PTLSurfBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLSurfBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Credit",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLSurfBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLSurfBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLSurfBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Credit")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLSurfBookingArray),
      expression: "PTLSurfBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLPay",
      "value": "To Pay"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLSurfBookingArray) ? _vm._i(_vm.PTLSurfBookingArray, "To Pay") > -1 : (_vm.PTLSurfBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLSurfBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "To Pay",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLSurfBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLSurfBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLSurfBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("FTC")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLSurfBookingArray),
      expression: "PTLSurfBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLPrePaid",
      "value": "PrePaid"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLSurfBookingArray) ? _vm._i(_vm.PTLSurfBookingArray, "PrePaid") > -1 : (_vm.PTLSurfBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLSurfBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "PrePaid",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLSurfBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLSurfBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLSurfBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Prepaid")])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLAir),
      expression: "PTLAir"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLAir"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLAir) ? _vm._i(_vm.PTLAir, null) > -1 : (_vm.PTLAir)
    },
    on: {
      "click": _vm.chkPTLrouteModeAir,
      "__c": function($event) {
        var $$a = _vm.PTLAir,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLAir = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLAir = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLAir = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Air")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLAirServiceArray),
      expression: "PTLAirServiceArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLForward",
      "value": "Forward"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLAirServiceArray) ? _vm._i(_vm.PTLAirServiceArray, "Forward") > -1 : (_vm.PTLAirServiceArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLAirServiceArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Forward",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLAirServiceArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLAirServiceArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLAirServiceArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Forward")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLAirBookingArray),
      expression: "PTLAirBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLCredit",
      "value": "Credit"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLAirBookingArray) ? _vm._i(_vm.PTLAirBookingArray, "Credit") > -1 : (_vm.PTLAirBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLAirBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Credit",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLAirBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLAirBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLAirBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Credit")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLAirBookingArray),
      expression: "PTLAirBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLPay",
      "value": "To Pay"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLAirBookingArray) ? _vm._i(_vm.PTLAirBookingArray, "To Pay") > -1 : (_vm.PTLAirBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLAirBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "To Pay",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLAirBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLAirBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLAirBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("FTC")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLAirBookingArray),
      expression: "PTLAirBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLPrePaid",
      "value": "PrePaid"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLAirBookingArray) ? _vm._i(_vm.PTLAirBookingArray, "PrePaid") > -1 : (_vm.PTLAirBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLAirBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "PrePaid",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLAirBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLAirBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLAirBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Prepaid")])])])])])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isServiceSelected),
      expression: "!isServiceSelected"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Atleast One Service\n              ")])], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-headerfrm1"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Service Levels")]), _vm._v(" "), (_vm.loadaccordian) ? _c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Truck Load Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Route Mode ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Service Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Booking Type ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])]), _vm._v(" "), (_vm.ptlerror.length > 0 || _vm.ftlerror.length > 0) ? _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Error")])]) : _vm._e()])]), _vm._v(" "), (_vm.accordiandata.length == 0) ? _c('tbody', [(_vm.accordiandata.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No Records Found")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.accordiandata), function(data, index) {
    return (_vm.accordiandata.length > 0) ? _c('tbody', [_c('tr', {
      attrs: {
        "id": _vm.loadtab + index
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.loadtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.servicetype))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.bokkingtype.join(", ")))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      attrs: {
        "title": "view"
      },
      on: {
        "click": function($event) {
          _vm.ShowServiceDetails(index)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "height": "16",
        "width": "16",
        "src": "/static/img/view.png"
      }
    })])])]), _vm._v(" "), (_vm.opened.includes(index)) ? _c('tr', {
      attrs: {
        "colspan": 6,
        "id": 'innerTable' + index
      }
    }, [_c('td', {
      attrs: {
        "colspan": 6
      }
    }, [_c('b-card', [(_vm.loadtab == 'FTL') ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [(_vm.serviceLevelIdForFtlDownload && _vm.ftlObject[data.key].servicetypezonetozonecitytocity == 1) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 5px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForFtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (City to City) ")])]) : _vm._e(), _vm._v(" "), (_vm.serviceLevelIdForFtlDownload && _vm.ftlObject[data.key].servicetypezonetozonecitytocity == 2) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 5px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForFtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (Zone to Zone)")])]) : _vm._e(), _vm._v(" "), (_vm.serviceLevelIdForFtlDownload && _vm.ftlObject[data.key].servicetypezonetozonecitytocity == 2 && _vm.ftlObject[data.key].uploadadditionalcities == 1) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 5px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForFtl(data.key, 1)
        }
      }
    }, [_vm._v("Download Sales TAT (Additional Cities)")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.loadtab == 'PTL') ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [(_vm.serviceLevelIdForPtlDownload && _vm.ptlObject[data.key].servicetypezonetozonecitytocity == 1) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 15px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForPtl(data.key, 1)
        }
      }
    }, [_vm._v("Download Sales TAT (City to City) ")])]) : _vm._e(), _vm._v(" "), (_vm.serviceLevelIdForPtlDownload && _vm.ptlObject[data.key].servicetypezonetozonecitytocity == 2) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 15px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForPtl(data.key, 2)
        }
      }
    }, [_vm._v("Download Sales TAT (Zone to Zone)")])]) : _vm._e(), _vm._v(" "), (_vm.serviceLevelIdForPtlDownload && _vm.ptlObject[data.key].servicetypezonetozonecitytocity == 2 && _vm.ptlObject[data.key].uploadadditionalcities == 1) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 5px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForPtl(data.key, 1)
        }
      }
    }, [_vm._v("Download Sales TAT (Additional Cities) ")])]) : _vm._e()]) : _vm._e()])], 1)]) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('br')])])])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c071f78e","hasScoped":true}!./src/modules/masterdata/views/contracttemplate/contracttemplateview/serviceview/serviceview.component.html
// module id = 679
// module chunks = 3